import {PropsWithChildren} from "react";
import {Button, Result} from "antd";
import {GetCoachUpcomingCallsApiResponse} from "../../../react-query-hooks/session/upcoming-calls/types";
import {createContext} from "../../create-context";
import {useGetCoachUpcomingCalls} from "../../../react-query-hooks/session/upcoming-calls";
import {FullPageLoader} from "../../../components/full-page-loader";

type GetCoachUpcomingCallsState = {
  coachUpcomingCallsData: GetCoachUpcomingCallsApiResponse;
  isFetchingCoachUpcomingCalls: boolean;
  isLoadingCoachUpcomingCalls: boolean;
  refetchCoachUpcomingCalls: () => void;
};

type GetCoachUpcomingCallsContextState = {
  state: GetCoachUpcomingCallsState;
};

const [useContext, ContextProvider] = createContext<GetCoachUpcomingCallsContextState>();

export const useGetCoachUpcomingCallsContext = useContext;

export const GetCoachUpcomingCallsProvider = ({children}: PropsWithChildren) => {
  const getCoachUpcomingCallsQuery = useGetCoachUpcomingCalls();

  if (getCoachUpcomingCallsQuery.isLoading) {
    return <FullPageLoader />;
  }

  if (getCoachUpcomingCallsQuery.isError && !getCoachUpcomingCallsQuery.data) {
    return (
      <Result
        status="500"
        title="Sorry, something went wrong."
        subTitle="Error fetching upcoming calls"
        extra={
          <Button
            type="primary"
            size="small"
            onClick={() => getCoachUpcomingCallsQuery.refetch()}
          >
            Try again
          </Button>
        }
      />
    );
  }

  function refetchCoachUpcomingCalls() {
    getCoachUpcomingCallsQuery.refetch();
  }

  const state: GetCoachUpcomingCallsState = {
    coachUpcomingCallsData: getCoachUpcomingCallsQuery.data,
    isFetchingCoachUpcomingCalls: getCoachUpcomingCallsQuery.isFetching,
    isLoadingCoachUpcomingCalls: getCoachUpcomingCallsQuery.isLoading,
    refetchCoachUpcomingCalls,
  };

  return <ContextProvider value={{state}}>{children}</ContextProvider>;
};
